module.exports = __webpack_public_path__ + "static/img/n-clock-start.d2f8ebb8.png";